import React from 'react';
import { SideBar } from './../../sidebar';
import { createUser, deleteUser, getUserInfo, getUsers, roles } from '../../../../models/users';
import DataTable from 'react-data-table-component';
import i18n from '../../../../i18n';
import { Modal, Spinner } from 'react-bootstrap';
import { EditUser } from './../../helper/edit_user';
import { getLoggedUser } from '../../../../state/user';
import HeaderBanner from '../../../common/HeaderBanner';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import FilterSection from '../../../common/Filter';
import Tooltip from '../../../common/Tooltip';
import { ConfirmModal } from '../../../common/ConfirmModal';
import NewDropdown from '../../../common/NewDropDown';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../../utils/downloadFile';
import { apiUrl } from '../../../../constants/global';
import {
    AlertTriangle,
    Download,
    Edit,
    Expand,
    Eye,
    FileSpreadsheet,
    Plus,
    Printer,
    Shrink,
    Trash,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const user = getLoggedUser();

const canSelectRole = ['A', 'OM', 'GM', 'CE'].includes(user?.role);

export class UsersList extends React.Component {
    constructor() {
        super();
        this.state = {
            open_popup: false,
            update_popup: false,
            add: {
                country_code: '+968',
            },
            data: {},
            errors: {},
            is_loading: false,
            users: [],
            hideSidebar: false,
            totalRows: 0,
            page: 1,
            limit: 15,
            search: {
                qtext: '',
                id: '',
                role: canSelectRole ? '' : 'U',
            },
            showDelete: false,
            selectedUserId: null,
            deleteLoading: false,
            exportLoading: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleAddChange = this.handleAddChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.triggerReload = this.triggerReload.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
        this.submitDelete = this.submitDelete.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadAllUsers();
    }

    buildQuery() {
        const { page, limit, search } = this.state;
        const q = { page, limit };
        if (search.qtext) q.qtext = search.qtext;
        if (search.id) q.id = search.id;
        if (search.role) q.role = search.role;
        return new URLSearchParams(q).toString();
    }

    async loadAllUsers() {
        this.setState({ is_loading: true });
        const qstring = this.buildQuery();
        const response = await getUsers(qstring);
        if (response.success) {
            this.setState({
                users: response.data,
                totalRows: response.meta.total,
                is_loading: false,
            });
        } else {
            this.setState({ is_loading: false });
        }
    }

    handleChange(event) {
        let { add } = this.state;
        // kept for backward-compat with any inline add-form fields using name/value
        add[event.target.name] = event.target.value;
        this.setState({ add });
    }

    handleAddChange(event) {
        let { add } = this.state;
        add[event.target.name] = event.target.value;
        this.setState({ add });
    }

    handleSearchChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            search: { ...prevState.search, [name]: value },
        }));
    };

    handleSearch() {
        this.setState({ page: 1 }, () => this.loadAllUsers());
    }

    handleClear() {
        this.setState(
            {
                search: { qtext: '', id: '', role: canSelectRole ? '' : 'U' },
                page: 1,
            },
            () => this.loadAllUsers()
        );
    }

    onChangePage(page) {
        window.scrollTo(0, 250);
        this.setState({ page }, () => this.loadAllUsers());
    }

    onChangeRowsPerPage(limit) {
        this.setState({ limit, page: 1 }, () => this.loadAllUsers());
    }

    async viewRow(id) {
        const response = await getUserInfo(id);
        let data = response.data;
        this.setState({ data, update_popup: true });
    }

    handleDelete = (row) => {
        this.setState({ selectedUserId: row.id, showDelete: true });
    };

    async submitDelete() {
        const { selectedUserId } = this.state;
        if (!selectedUserId) return;
        this.setState({ deleteLoading: true });
        try {
            const response = await deleteUser(selectedUserId);
            if (response.success) {
                toast.success('User deleted successfully');
                this.loadAllUsers();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ deleteLoading: false, showDelete: false, selectedUserId: null });
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.validate()) {
            try {
                const response = await createUser(this.state.add);
                if (response.success) {
                    toast.success('User created successfully!!');
                    this.resetForm();
                    this.setState({ open_popup: false });
                    this.loadAllUsers();
                } else {
                    let error_message = response.message;
                    let resObject = response.data;
                    for (const key in resObject) {
                        if (Object.hasOwnProperty.call(resObject, key)) {
                            error_message += '\n' + resObject[key];
                        }
                    }
                    toast.error(error_message);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    resetForm() {
        let { add } = this.state;
        add['name'] = '';
        add['mobile'] = '';
        add['email'] = '';
        add['username'] = '';
        add['country_code'] = '+968';
        add['password'] = '';
        add['role'] = '';
        this.setState({ add: add });
    }

    validate() {
        let input = this.state.add;
        let errors = {};
        let isValid = true;
        if (!input['name']) {
            isValid = false;
            errors['name'] = 'Please enter your Name.';
        }
        if (!input['username']) {
            isValid = false;
            errors['username'] = 'Please enter a valid Username.';
        }
        if (!input['country_code']) {
            isValid = false;
            errors['country_code'] = 'Please enter phone country code.';
        }
        if (!input['mobile']) {
            isValid = false;
            errors['mobile'] = 'Please enter your Phone Number.';
        }

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (!input['email'] || !pattern.test(input['email'])) {
            isValid = false;
            errors['email'] = 'Please enter valid email address.';
        }
        if (!input['password']) {
            isValid = false;
            errors['password'] = 'Please enter your Password.';
        }
        if (!input['role']) {
            isValid = false;
            errors['role'] = 'Please select a role.';
        }

        this.setState({ errors });
        return isValid;
    }

    triggerReload(opt) {
        if (opt) {
            this.loadAllUsers();
        }
    }

    handleDownload = async (fileType) => {
        this.setState({ exportLoading: true });
        try {
            const { search } = this.state;
            const params = { fileType };
            if (search.qtext) params.qtext = search.qtext;
            if (search.role) params.role = search.role;

            await downloadFile({
                url: `${apiUrl}v2/report/users`,
                params,
                token: user.token,
                fileType,
                fileName: 'Users_Report',
            });
        } finally {
            this.setState({ exportLoading: false });
        }
    };

    getColumns = () => {
        const isAdmin = user?.role === 'A';
        return [
            {
                name: i18n.t('id'),
                selector: (row) => row.id,
                sortable: true,
                wrap: true,
                width: '80px',
            },
            {
                name: i18n.t('name'),
                selector: (row) => row.name,
                sortable: true,
                wrap: true,
            },
            {
                name: i18n.t('username'),
                selector: (row) => row.username,
                sortable: true,
                wrap: true,
            },
            {
                name: i18n.t('role'),
                selector: (row) => row.role,
                wrap: true,
                cell: (row) => roles[row.role],
            },
            {
                name: i18n.t('email'),
                selector: (row) => row.email,
                wrap: true,
            },
            {
                id: 'cr_file',
                name: i18n.t('cr_file'),
                // width: '110px',
                cell: (row) =>
                    row.file_cr_number ? (
                        <a
                            className="button-table"
                            href={row.file_cr_number}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FileSpreadsheet size={18} /> {i18n.t('cr_file')}
                        </a>
                    ) : (
                        <span className="attachment-empty">{i18n.t('no_cr_file')}</span>
                    ),
                wrap: true,
            },
            {
                id: 'id_card',
                name: i18n.t('id_card'),
                // width: '110px',
                cell: (row) =>
                    row.file_id_number ? (
                        <a
                            className="button-table"
                            href={row.file_id_number}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FileSpreadsheet size={18} /> {i18n.t('id_card')}
                        </a>
                    ) : (
                        <span className="attachment-empty">{i18n.t('no_id_card')}</span>
                    ),
                wrap: true,
            },
            {
                name: i18n.t('mobile'),
                selector: (row) => row.mobile,
                wrap: true,
                cell: (row) => `${row.country_code} ${row.mobile}`,
            },
            ...(isAdmin
                ? [
                    {
                        name: i18n.t('Actions'),
                        width: '110px',
                        center: true,
                        cell: (row) => (
                            <div className="table-row">
                                <Tooltip
                                    icon={Eye}
                                    tooltipText={i18n.t('view')}
                                    onClick={() => this.viewRow(row.id)}
                                    size={16}
                                    className="primary-color"
                                />
                                {row.role === 'A' ? (
                                    <span className="text-danger" style={{ marginLeft: '0.5rem' }}>

                                    </span>
                                ) : (
                                    <Tooltip
                                        icon={Trash}
                                        tooltipText={i18n.t('delete')}
                                        onClick={() => this.handleDelete(row)}
                                        size={16}
                                        className="danger-color"
                                    />
                                )}
                            </div>
                        ),
                    },
                ]
                : []),
        ];
    };

    render() {
        const { users, is_loading, totalRows, deleteLoading, showDelete, exportLoading, search } =
            this.state;

        return (
            <React.Fragment>
                <HeaderBanner title={i18n.t('users')} subtitle={i18n.t('users_list_subtitle')} />
                <section className="dashboard-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div
                                className={
                                    this.state.hideSidebar
                                        ? 'col-xl-12 col-lg-12 col-md-12'
                                        : 'col-xl-9 col-lg-12 col-md-12'
                                }
                            >
                                <div className="card">
                                    <div className="card-header">
                                        <div className="expand-dashboard">
                                            <span
                                                style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                                onClick={() => {
                                                    this.setState({ hideSidebar: !this.state.hideSidebar });
                                                }}
                                            >
                                                {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                                                {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                                            </span>
                                        </div>
                                        <div className="header-action">
                                            {user?.role === 'A' && (
                                                <button
                                                    className="button1 button1-gradient"
                                                    onClick={() => this.setState({ open_popup: true })}
                                                >
                                                    <Plus size={18} />
                                                    <span>{i18n.t('add_new_user')}</span>
                                                </button>
                                            )}
                                            {user?.role === 'F' && (
                                                <NewDropdown
                                                    label={i18n.t('export')}
                                                    loading={exportLoading}
                                                    icon={Download}
                                                    items={[
                                                        {
                                                            label: i18n.t('excel'),
                                                            icon: FileSpreadsheet,
                                                            onClick: () => this.handleDownload('excel'),
                                                        },
                                                        {
                                                            label: i18n.t('pdf'),
                                                            icon: Printer,
                                                            disabled: true,
                                                        },
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <FilterSection
                                            loading={is_loading}
                                            onSearch={this.handleSearch}
                                            onClear={this.handleClear}
                                        >
                                            <div className="select-wrapper floating-label-wrapper">
                                                <input
                                                    id="id"
                                                    type="number"
                                                    name="id"
                                                    value={search.id || ''}
                                                    onChange={this.handleSearchChange}
                                                    className="filter-base floating-input"
                                                    placeholder=" "
                                                    min="0"
                                                />
                                                <label htmlFor="id" className="floating-label">
                                                    {i18n.t('user_id')}
                                                </label>
                                            </div>
                                            
                                            <div className="select-wrapper floating-label-wrapper">
                                                <input
                                                    id="qtext"
                                                    type="text"
                                                    name="qtext"
                                                    value={search.qtext || ''}
                                                    onChange={this.handleSearchChange}
                                                    className="filter-base floating-input"
                                                    placeholder=" "
                                                />
                                                <label htmlFor="qtext" className="floating-label">
                                                    {i18n.t('search_by_name_username_email_or_phone')}
                                                </label>
                                            </div>

                                            {canSelectRole && (
                                                <div className="react-select-wrapper">
                                                    <Select
                                                        options={Object.keys(roles).map((rKey) => ({
                                                            value: rKey,
                                                            label: roles[rKey],
                                                        }))}
                                                        value={
                                                            search.role
                                                                ? { value: search.role, label: roles[search.role] }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            this.setState((prevState) => ({
                                                                search: {
                                                                    ...prevState.search,
                                                                    role: selectedOption ? selectedOption.value : '',
                                                                },
                                                            }));
                                                        }}
                                                        name="role"
                                                        styles={selectStyles}
                                                        menuPlacement="auto"
                                                        menuPortalTarget={document.body}
                                                        placeholder={i18n.t('select_any_role')}
                                                        isClearable
                                                    />
                                                    <label className="react-select-label">{i18n.t('role')}</label>
                                                </div>
                                            )}
                                        </FilterSection>

                                        <div className="Data-Listing">
                                            {is_loading ? (
                                                <TableSkeleton columns={7} rows={10} />
                                            ) : users.length ? (
                                                <DataTable
                                                    responsive={true}
                                                    columns={this.getColumns()}
                                                    data={users}
                                                    customStyles={tableStyles}
                                                    highlightOnHover
                                                    pagination
                                                    paginationServer
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={this.state.limit}
                                                    paginationDefaultPage={this.state.page}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 100]}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: i18n.t('rows_per_page'),
                                                        rangeSeparatorText: i18n.t('out'),
                                                    }}
                                                    onChangePage={this.onChangePage}
                                                    onChangeRowsPerPage={this.onChangeRowsPerPage}
                                                />
                                            ) : (
                                                <NoData
                                                    message={i18n.t('no_users_available')}
                                                    actionText={i18n.t('refresh')}
                                                    onAction={() => this.loadAllUsers()}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Add user modal */}
                <Modal
                    size="lg"
                    show={this.state.open_popup}
                    onHide={() => this.setState({ open_popup: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg">{i18n.t('add_new_user')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="single-page">
                                <div className="col-md-12 d-block mx-auto">
                                    <div className="wrapper wrapper2">
                                        <form id="Register" className="card-body" tabIndex="500" autoComplete="off">
                                            <div className="name mb-1">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={this.state.add.name}
                                                    onChange={this.handleAddChange}
                                                    autoComplete="name"
                                                    className="form-control custom-input rounded-pill"
                                                />
                                                <label>{i18n.t('name')}</label>
                                                <div className="text-danger">{this.state.errors.name}</div>
                                            </div>

                                            <div className="mb-1">
                                                <label>{i18n.t('phone_number')}</label>
                                                <div className="input-group input-group-sm mt-2">
                                                    <span className="country-flag-field border col-1">
                                                        <img
                                                            src={process.env.PUBLIC_URL + '/assets/images/flags/ar.svg'}
                                                            alt=""
                                                            width="25"
                                                            height="25"
                                                        />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control col-9"
                                                        style={{ zIndex: 0 }}
                                                        name="mobile"
                                                        value={this.state.add.mobile}
                                                        onChange={this.handleAddChange}
                                                    />
                                                </div>
                                                <div className="text-danger">{this.state.errors.mobile}</div>
                                            </div>

                                            <div className="email mb-1">
                                                <label>{i18n.t('email')}</label>
                                                <input
                                                    type="text"
                                                    name="email"
                                                    value={this.state.add.email}
                                                    onChange={this.handleAddChange}
                                                    style={{ direction: 'ltr' }}
                                                    className="form-control custom-input rounded-pill"
                                                />
                                                <div className="text-danger">{this.state.errors.email}</div>
                                            </div>

                                            <div className="username mb-1">
                                                <label>{i18n.t('username')}</label>
                                                <input
                                                    type="text"
                                                    name="username"
                                                    value={this.state.add.username}
                                                    onChange={this.handleAddChange}
                                                    autoComplete="username"
                                                    className="form-control custom-input rounded-pill"
                                                />
                                                <div className="text-danger">{this.state.errors.username}</div>
                                            </div>

                                            <div className="passwd mb-1">
                                                <label>{i18n.t('password')}</label>
                                                <input
                                                    type="text"
                                                    name="password"
                                                    value={this.state.add.password}
                                                    onChange={this.handleAddChange}
                                                    className="form-control custom-input rounded-pill"
                                                />
                                                <div className="text-danger">{this.state.errors.password}</div>
                                            </div>

                                            <div className="mb-1">
                                                <label>{i18n.t('role')}</label>
                                                <select
                                                    className="form-control"
                                                    name="role"
                                                    value={this.state.add.role}
                                                    onChange={this.handleAddChange}
                                                >
                                                    <option value="">-- {i18n.t('select_any_role')} --</option>
                                                    {Object.keys(roles).map((rKey, i) => (
                                                        <option value={rKey} key={i}>
                                                            {roles[rKey]}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div className="text-danger">{this.state.errors.role}</div>
                                            </div>

                                            <button
                                                type="button"
                                                className="btn btn-primary btn-block mt-5"
                                                onClick={this.handleSubmit}
                                            >
                                                {i18n.t('submit')}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* View/Edit user modal */}
                <Modal
                    size="md"
                    show={this.state.update_popup}
                    onHide={() => this.setState({ update_popup: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg">
                            {i18n.t('view_edit_user')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <EditUser data={this.state.data} triggerReload={this.triggerReload} />
                    </Modal.Body>
                </Modal>

                <ConfirmModal
                    show={showDelete}
                    onClose={() => this.setState({ showDelete: false, selectedUserId: null })}
                    title={'Confirm User Deletion'}
                    titleIcon={<AlertTriangle size={22} color="#dc3545" />}
                    message={'Are You Sure You Want to Delete This User?'}
                    onConfirm={this.submitDelete}
                    onCancel={() => this.setState({ showDelete: false, selectedUserId: null })}
                    confirmText={'Delete'}
                    cancelText="Cancel"
                    loading={deleteLoading}
                ></ConfirmModal>
            </React.Fragment>
        );
    }
}

export default UsersList;